module.exports = __webpack_public_path__ + "img/2.3a1319b8.png";